<div class="pageheader">
  <div class="page-title">
    <h1>Distribution Search Result</h1>
    <div class="btn-group" data-toggle="buttons">
      <button class="btn btn-link" id="btnNew" *bizPermissionRequired="'Distribution_Action_DistributionCreate'" (click)="createNew()">Create new <ep-svg-icon icon="plus"></ep-svg-icon></button>
    </div>
  </div>
  <restricted-search-callout [visible]="$safeNavigationMigration(stateObject.searchResult?.IsDistributionSearchResultRestricted)"></restricted-search-callout>
</div>
@if (stateObject.searchResult?.DistributionGroups?.length > 1) {
  <div>
    <div class="controls-inline">
      @for (group of stateObject.searchResult?.DistributionGroups; track group) {
        <div class="control control-checkbox" [class.active]="group.selected">
          <label [title]="group.DistributionObjectGroupDescription ?? ''">
            <span>{{group.DistributionObjectGroupName}}</span>
            <input type="checkbox" [(ngModel)]="group.selected" (ngModelChange)="selectedGroupsChanged()">
            <i></i>
          </label>
        </div>
      }
    </div>
  </div>
}


<!--<h5>Document types</h5>-->
<div class="nav-tabs-filter">
  <ul class="nav nav-tabs" ngbNav [(activeId)]="stateObject.selectedDistributionObjectContainer" (activeIdChange)="selectedDistributionObjectsChanged()">
    @for (item of stateObject.distributionObjectsContainers; track item) {
      <li [ngbNavItem]="item">
        <a ngbNavLink [title]="item.DistributionObjectDescription" class="btn">{{item.DistributionObjectName}} ({{item.Distributions.length}})</a>
      </li>
    }
  </ul>
</div>

<div class="btn-toolbar">
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Distribution_View_DistributionDetails'" [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="showDistributions()" id="showDistributionsButton">Show Distributions</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Distribution_Action_DistributionExport'" [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="export()" id="exportButton">Export</button>
  </div>
</div>

<dx-data-grid biz-grid
  exportFileName="Distribution Result"
  [bizSetStateStoring]="false"
  [dataSource]='stateObject.distributions'
  [selection]='{ mode: "multiple" }'
  (onSelectionChanged)='selectionChanged($event)'
  [showCollapseAllButton]="true"
  [showIsLoading]="isLoading"
  (onRefresh)="refresh()">

  <!-- Note: Not using bizGrid stateStoring due to issue with storage instance being null when navigating back to page after distribution deletion -->
  <dxo-state-storing [enabled]="true" type="sessionStorage" [storageKey]="stateKey" savingTimeout="500"></dxo-state-storing>

  <dxi-column dataField="IsActive" caption="Active" dataType="boolean"></dxi-column>
  <dxi-column
    name="IsFallback"
    caption="Fallback"
    dataType="boolean"
    [visible]="isFallbackColumnVisible"
    [calculateCellValue]="calculateIsFallback">
  </dxi-column>
  <dxi-column dataField="DistributionObjectName" caption="Document Type" dataType="string"></dxi-column>
  <dxi-column dataField="FromPartner" caption="From Partner" dataType="string"></dxi-column>
  <dxi-column dataField="ConcatenatedFormatVariantVersionFrom" caption="From format/variant/version" dataType="string"></dxi-column>
  <dxi-column dataField="ToPartner" caption="To Partner" dataType="string"></dxi-column>
  <dxi-column dataField="ConcatenatedFormatVariantVersionTo" caption="To format/variant/version" dataType="string"></dxi-column>
  <dxi-column dataField="TransportConfigurationTo" caption="To Configuration" dataType="string"></dxi-column>
  <dxi-column biz-grid-date dataField="LatestDocumentDate" caption="Last Activity" dataType="date"></dxi-column>
  <dxi-column dataField="LatestAlertStatus" caption="Alert Status" dataType="string" cellTemplate="alertStatusTemplate" alignment="center"></dxi-column>

  <dxi-column dataField="Description" caption="Description" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="SendAcknowledgement" caption="Send Acknowledgement">
    <dxo-lookup [dataSource]="acknowledgementOptions" valueExpr="value" displayExpr="name"></dxo-lookup>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="ExpectAcknowledgement" caption="Expect Acknowledgement" dataType="boolean" [visible]="false"></dxi-column>
  <dxi-column dataField="DefaultFilenaming" caption="Default Filenaming" dataType="boolean" [visible]="false"></dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(stateObject.distributions, 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(stateObject.distributions, 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

  <ng-container *dxTemplate="let cell of 'alertStatusTemplate'">
    <app-status-traffic-light [status]="cell.data.LatestAlertStatus" [tooltip]="alertStatusTooltip(cell.data.LatestAlertStatus)"></app-status-traffic-light>
  </ng-container>

</dx-data-grid>
